$shm_hitalama_teams_maps $shm_hitalama_map_catalog
	team $shm_hitalama_team
	param \team_map
	menu_title \Карты
	Add_map_menu $mol_list
		rows /
			<= Add_team $mol_button_minor
				title \Совместная карта
				click? <=> team_add? null
